export const SPostCell = {
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center'
};
